import React, { forwardRef } from "react";

import { format } from "date-fns";

import { Box, Flex, Spacer, Text, HStack, Stack } from "@chakra-ui/react";
import logoMCA from "../../../img-docs/logomca.png";

import { IrmaoTable } from "../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import SemRegistros from "../SemRegistros";

export const ComponentToPrintRelatorioCrianca = forwardRef((props, ref) => {
  return (
    <Box display="block" ref={ref}>
      <table style={{ width: props?.dataPendencias?.length <= 0 && "100%" }}>
        <thead>
          <tr>
            <td>
              {/* Header Spacer */}
              <Box height="80px" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Box display="break-page">
                <Stack alignItems="center" p={10}>
                  <Text fontSize={"3xl"} fontWeight={700} color="#6A6A6A">
                    Relatório de Crianças e Adolescentes
                  </Text>
                  <Text>{""}</Text>
                  <Flex
                    w={"full"}
                    bgColor={"#16949933"}
                    px="20px"
                    py="16px"
                    border={"solid 1px #DEE2E6"}
                    borderTop={"solid 3px #169499"}
                    alignItems="start"
                    flexDirection={"column"}
                    gap={3}
                    cursor={"pointer"}
                    mt={10}
                  >
                    <Text
                      color={"#1A203D"}
                      fontWeight="500"
                      fontSize="18px"
                      lineHeight="21.6px"
                    >
                      Serviço de Acolhimento:{" "}
                      {props?.storage?.idsServicosAcolhimento?.length
                        ? props?.storage?.idsServicosAcolhimento
                            ?.flat()
                            ?.map((item) => item.label)
                            ?.join("; ")
                        : props?.storage?.idsServicosAcolhimento?.label ||
                          "Todos"}
                    </Text>
                    <Text
                      color={"#1A203D"}
                      fontWeight="500"
                      fontSize="16px"
                      lineHeight="21.6px"
                    >
                      Universo da Consulta:{" "}
                      {props?.storage?.universoConsulta?.label || "Todos"}
                    </Text>

                    {props?.storage?.universoConsulta?.id === 3 && (
                      <Text
                        color={"#1A203D"}
                        fontWeight="500"
                        fontSize="16px"
                        lineHeight="21.6px"
                      >
                        Tipo de Transferência:{" "}
                        {props?.storage?.idTipoTransferencia?.label || "Todos"}
                      </Text>
                    )}

                    {((props?.storage?.universoConsulta?.id === 3 &&
                      (props?.storage?.idTipoTransferencia?.id === 2 ||
                        props?.storage?.idTipoTransferencia?.id === 6)) ||
                      props?.storage?.universoConsulta?.id === 4) && (
                      <Text
                        color={"#1A203D"}
                        fontWeight="500"
                        fontSize="16px"
                        lineHeight="21.6px"
                      >
                        Justificativa:{" "}
                        {(props?.storage?.idJustificativas?.length &&
                          props?.storage?.idJustificativas
                            ?.flat()
                            ?.map((item) => item.descricao?.replace(/\.$/, ""))
                            ?.join("; ")) ||
                          "Todos"}
                      </Text>
                    )}

                    {(props?.storage?.universoConsulta?.id === 1 ||
                      props?.storage?.universoConsulta?.id === 2) && (
                      <Text
                        color={"#1A203D"}
                        fontWeight="500"
                        fontSize="16px"
                        lineHeight="21.6px"
                      >
                        Motivo:{" "}
                        {(props?.storage?.idsMotivosEntrada?.length &&
                          props?.storage?.idsMotivosEntrada
                            ?.flat()
                            ?.map((item) => item.descricao)
                            ?.join("; ")) ||
                          "Todos"}
                      </Text>
                    )}

                    {props?.storage?.tipoPeriodo === "A" ? (
                      <Text
                        color={"#1A203D"}
                        fontWeight="500"
                        fontSize="16px"
                        lineHeight="21.6px"
                      >
                        Período: {"Situação Atual"}
                      </Text>
                    ) : (
                      <Flex gap={4}>
                        {props?.storage?.dataInicio && (
                          <Text
                            color={"#1A203D"}
                            fontWeight="500"
                            fontSize="16px"
                            lineHeight="21.6px"
                          >
                            Período de: {props?.storage?.dataInicio || ""}
                          </Text>
                        )}

                        {props?.storage?.dataFim && (
                          <Text
                            color={"#1A203D"}
                            fontWeight="500"
                            fontSize="16px"
                            lineHeight="21.6px"
                          >
                            Até: {props?.storage?.dataFim || ""}
                          </Text>
                        )}
                      </Flex>
                    )}

                    {(props?.storage?.entradasPorTransferencias?.includes(
                      "Possui",
                    ) ||
                      props?.storage?.saidaTransferencia?.includes("Possui") ||
                      props?.storage?.maioresDezoito?.includes("Possui")) && (
                      <Text
                        color={"#1A203D"}
                        fontWeight="500"
                        fontSize="16px"
                        lineHeight="21.6px"
                      >
                        Deseja Incluir:{" "}
                        {[
                          props?.storage?.entradasPorTransferencias?.includes(
                            "Possui",
                          ) && "Entradas por Transferências",
                          props.storage?.saidaTransferencia?.includes(
                            "Possui",
                          ) && "Saídas por Transferências",
                          props.storage?.maioresDezoito?.includes("Possui") &&
                            (props.storage?.universoConsulta?.id === 4
                              ? "Os Maiores de 18 Anos que Não se Encontram na Situação de Pendente"
                              : "Maiores de 18 Anos"),
                        ]
                          .filter(Boolean)
                          .join("; ") || ""}
                      </Text>
                    )}
                  </Flex>

                  <Text>{""}</Text>

                  {props?.dataPendencias?.length > 0 ? (
                    <Box display={"block"}>
                      <IrmaoTable
                        mt={"0px"}
                        columns={props.columnsPendencias}
                        data={props.dataPendencias}
                        entidade="pendencias"
                        disableHeaderOptions={true}
                        isPrint={true}
                      />
                      <Text mt={4}>
                        Total de Registro(s): {props?.storage?.totalItems ?? 0}
                      </Text>
                    </Box>
                  ) : (
                    <Box w={"full"} display={"block"}>
                      <SemRegistros buttonVisible={true} half />
                    </Box>
                  )}
                </Stack>
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              {/* Footer Spacer */}
              <Box height="150px" />
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Header */}
      <HStack
        position="fixed"
        top={0}
        pt="17.5px"
        pl={"50px"}
        pb="10px"
        alignItems="end"
        justifyContent="space-between"
        backgroundColor="#FFF"
        zIndex={100}
        width="100%"
        borderBottom="solid 1px #D1D0CF"
      >
        <img
          src={logoMCA}
          alt="LogoMCA"
          style={{ width: "200px", height: "60px" }}
        />

        <Box width="200px" />
      </HStack>
      {/* Footer */}
      <Box
        position="fixed"
        bottom={10}
        pb="17.5px"
        pt="20px"
        w="100%"
        px="15px"
        backgroundColor="#006064"
        zIndex={100}
      >
        <Text color={"#fff"}>Usuário: {props?.user?.name}</Text>
        <Text color={"#fff"}>
          Orgão: {props?.dados?.nomeOrgao || props?.dados?.nomeOrgaoExterno}
        </Text>
        <Text color={"#fff"}>{`Data da impressão: ${format(
          new Date(),
          "dd/MM/yyyy",
        )} ${format(new Date(), "HH:mm:ss")}`}</Text>
      </Box>
      <Flex
        position="fixed"
        bottom={0}
        pt="10px"
        w="100%"
        px="15px"
        backgroundColor="#FFF"
        zIndex={100}
      >
        <HStack spacing="35px">
          <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
          <Text>{format(new Date(), "HH:mm:ss")}</Text>
        </HStack>

        <Spacer />

        <Text id="pageForPrint">Página</Text>
      </Flex>
    </Box>
  );
});
